import orb from './orb.jpg';
import curtainBg from './curtain-bg.jpg';
import mascotBodyRest from './mascot-body-rest.png';
import mascotBodyUp from './mascot-body-up.png';
import mascotHead from './mascot-head.png';
import mascotLegL from './mascot-leg-l.png';
import mascotLegR from './mascot-leg-r.png';
import mascotArm from './mascot-arm.png';

/** Imágenes que vienen con el frontend. El admin puede reemplazar cualquiera
 *  por URL desde Administración → Lumière (LMX); si no hay override, va ésta. */
export const DEFAULT_ASSETS = {
  orb,
  avatar_orb: orb,
  curtain_bg: curtainBg,
  mascot_body_rest: mascotBodyRest,
  mascot_body_up: mascotBodyUp,
  mascot_head: mascotHead,
  mascot_leg_l: mascotLegL,
  mascot_leg_r: mascotLegR,
  mascot_arm: mascotArm,
};

export const ASSET_LABELS = {
  orb: 'Burbuja (acceso)',
  avatar_orb: 'Burbuja (avatar del chat)',
  curtain_bg: 'Telón de entrada',
  mascot_body_rest: 'Lumière · cuerpo en reposo',
  mascot_body_up: 'Lumière · cuerpo con brazo',
  mascot_head: 'Lumière · cabeza',
  mascot_leg_l: 'Lumière · pierna izquierda',
  mascot_leg_r: 'Lumière · pierna derecha',
  mascot_arm: 'Lumière · brazo',
};

export const resolveAssets = (overrides) => {
  const out = { ...DEFAULT_ASSETS };
  Object.entries(overrides || {}).forEach(([k, v]) => {
    if (v) out[k] = v;
  });
  return out;
};
